import './dev-collabora-online.scss';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevCollaboraOnlineController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('~/scripts/services/form.service').default} FormService
	 */
	constructor($scope, FormService) {
		this.disabled = true;
		(async () => {
			this.node = await FormService.load('K_NODE;0000045MDY5FM7CRJBM0', { rg: true });
			this.file = this.node.files[0];
			$scope.$apply();
		})();
	}
}
